import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import RichText from "components/elements/richText"
import Button from "components/elements/styledButton"
import InfoIcon from "../../../../static/images/InfoIcon.svg"
import "./sectionReferralActions.scss"
import useMediaQuery from "utils/useMediaQuery"
import Wrapper from "components/sections/wrapper"
const SectionReferralActions = ({ contentTitle, referralButtons }) => {
  const [openTooltip, setOpenTooltip] = useState(null)
  const tooltipRefs = useRef([])
  const isMobile = useMediaQuery("(max-width: 540px)")
  const handleToggle = index => {
    if (!isMobile) return
    setOpenTooltip(openTooltip === index ? null : index)
  }

  useEffect(() => {
    const handleClickOutside = event => {
      if (!isMobile) return
      if (
        openTooltip !== null &&
        tooltipRefs.current[openTooltip] &&
        !tooltipRefs.current[openTooltip].contains(event.target)
      ) {
        setOpenTooltip(null)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [isMobile, openTooltip])

  return (
    <section className="section-referral-actions">
      {contentTitle && (
        <Wrapper {...contentTitle} className="careers-heading-wrapper" />
      )}
      <div className="container">
        <div className="section-referral-actions__buttons">
          {referralButtons?.map((btn, i) => (
            <div
              className="section-referral-actions__btn-wrapper"
              key={i}
              ref={el => (tooltipRefs.current[i] = el)}
            >
              <Button
                accessibilityLabel={btn.accessibilityLabel}
                className="text-lockup__button"
                color={[btn.color]}
                fullWidth={true}
                href={btn.href}
                isOutlined={btn.isOutlined}
                isSmall={btn.isSmall}
                text={btn.text}
              />
              {btn.tooltipText?.json && (
                <div
                  className={`section-referral-actions__tooltip-wrapper ${
                    openTooltip === i ? "is-open" : ""
                  }`}
                  onClick={() => handleToggle(i)}
                  onKeyDown={e => {
                    if (e.key === "Enter" || e.key === " ") handleToggle(i)
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <div className="info-icon-wrapper">
                    <img alt="Tooltip info icon" src={InfoIcon} />
                  </div>
                  <div className="section-referral-actions__tooltip">
                    <RichText
                      richText={{ json: btn.tooltipText.json }}
                      textStyle="full"
                    />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

SectionReferralActions.propTypes = {
  contentTitle: PropTypes.object,
  referralButtons: PropTypes.arrayOf(
    PropTypes.shape({
      accessibilityLabel: PropTypes.string,
      color: PropTypes.string,
      isOutlined: PropTypes.bool,
      isSmall: PropTypes.bool,
      href: PropTypes.string,
      text: PropTypes.string,
      tooltipText: PropTypes.shape({
        json: PropTypes.object,
      }),
    })
  ),
}

export default SectionReferralActions
